import { actionStyles as styles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        ${styles.wrapper?.css}
        align-items: center;
    `,
};

styles.buttonWrapper = {
    ...styles.buttonWrapper,
    css: css`
        ${styles.buttonWrapper?.css}
        width: fit-content;
        justify-content: flex-end;
    `,
};

styles.nameText = {
    ...styles.nameText,
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};

styles.overflowMenu = {
    ...styles.overflowMenu,
    cssOverrides: {
        wrapper: css`
            ${mediaQueriesBP.minMD} {
                margin-right: 15px;
            }
        `,
    },
};

styles.removeSelectedButton = {
    ...styles.removeSelectedButton,
    variant: "primary",
};
